// Module
var code = "<template> <require from=\"./view-header-triple-layout.scss\"></require> <div class=\"left\"> <slot name=\"left\"></slot> </div> <div class=\"center\"> <slot name=\"center\"></slot> </div> <div class=\"right\"> <slot name=\"right\"></slot> </div> </template> ";
// Exports
export default code;